<template>
  <div class="mt-n4">
    <div v-if="getGoalieLoader">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
          :loading="getGoalieLoader"
          class="ma-2"
          type="card@2"
          elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <div class="startinggoliessection" v-else>
      <v-row class="m-0">
        <v-col
          cols="12"
          md="6"
          sm="12"
          class="mx-auto"
          v-for="item in goaliesData.data"
          :key="item._id"
        >
          <div class="startinggolinner">
            <base-title-bar
              elevation="2"
              class="text-center titlegolis"
              color="#72C604"
              :label="`${item.AwayTeamCity} ${item.AwayTeamName} at ${item.HomeTeamCity} ${item.HomeTeamName}`"
              icon="mdi-hockey-sticks"
              height="50"
              textProp="pt-2 text-subtitle-1 white--text"
            />
            <div class="dategolis">
              <div class="text-center">
                <span>{{ item.DateTime | dayFormat }} EST</span>
              </div>
            </div>

            <!--//* goalies cards.. -->
            <v-card class="mx-auto goalies-design" elevation="2">
              <v-card-text>
                <v-row>
                  <!-- //! AwayTeam goalie  -->
                  <v-col cols="12" md="6" sm="6">
                    <div class="teambox-golis leftteams">
                      <div class="goliplayer-img">
                        <v-avatar width="80" tile size="100" color="#ECEFF1">
                          <img :src="item.AwayPlayerLogo" />
                        </v-avatar>
                      </div>
                      <div class="golidetail">
                        <span class="body-2 font-weight-bold playernamgoli"
                          >{{ item.AwayFirstName }}
                          {{ item.AwayLastName }}</span
                        >
                        <span
                          v-if="item.AwayConfirmed == 'false'"
                          class="body-2 red--text font-weight-bold"
                        >
                          Unconfirmed <br />
                        </span>
                        <span
                          v-else-if="item.AwayConfirmed == 'true'"
                          class="body-2 green--text font-weight-bold"
                        >
                          Confirmed <br />
                        </span>
                        <span
                          class="caption linecombo font-weight-bold links"
                          @click.stop="getDepthChart(item.AwayTeamID)"
                        >
                          Line Combos <br />
                        </span>
                      </div>
                      <div class="goli-temlogo">
                        <v-avatar
                          tile
                          width="80"
                          size="100"
                          color="#ECEFF1"
                          class="float-right"
                        >
                          <img :src="item.AwayTeamLogo" />
                        </v-avatar>
                      </div>
                    </div>
                    <!-- <p class="pt-3 pt-md-0  text-center">No Goalie Details Yet.</p> -->
                  </v-col>

                  <!-- <v-divider vertical></v-divider> -->

                  <!-- //! HomeTeam goalie  -->
                  <v-col cols="12" md="6" sm="6">
                    <div class="teambox-golis righteams">
                      <div class="goli-temlogo">
                        <v-avatar tile width="80" size="100" color="#ECEFF1">
                          <img :src="item.HomeTeamLogo" />
                        </v-avatar>
                      </div>
                      <div class="golidetail">
                        <span class="body-2 font-weight-bold playernamgoli"
                          >{{ item.HomeFirstName }}
                          {{ item.HomeLastName }}</span
                        >
                        <span
                          v-if="item.HomeConfirmed == 'false'"
                          class="body-2 red--text font-weight-bold"
                        >
                          Unconfirmed <br />
                        </span>
                        <span
                          v-else-if="item.HomeConfirmed == 'true'"
                          class="body-2 green--text font-weight-bold"
                        >
                          Confirmed <br />
                        </span>

                        <span
                          class="caption linecombo font-weight-bold links"
                          @click.stop="getDepthChart(item.HomeTeamID)"
                        >
                          Line Combos <br />
                        </span>
                      </div>
                      <div class="goliplayer-img">
                        <v-avatar
                          tile
                          width="80"
                          size="100"
                          color="#ECEFF1"
                          class="float-right"
                        >
                          <img height="50%" :src="item.HomePlayerLogo" />
                        </v-avatar>
                      </div>
                    </div>
                    <!-- <p class="pt-3 pt-md-0 text-center">No Goalie Details Yet.</p> -->
                  </v-col>
                </v-row>

                <v-sheet rounded class="my-2" color="#81C784">
                  <v-row justify="center" align="center">
                    <!-- away -->
                    <v-col md="4" align-self="center">
                      <p class="body-2 text-end">
                        Money Line :
                        <span class="font-weight-medium">
                          {{
                            item.AwayTeamMoneyLine ? item.AwayTeamMoneyLine : 0
                          }}
                        </span>
                      </p>
                    </v-col>

                    <!-- over under -->
                    <v-col md="4" align-self="center">
                      <p
                        class="body-2 text-center black--text font-weight-medium"
                      >
                        <span class="font-weight-regular">Over Under: </span>
                        {{ item.OverUnder ? item.OverUnder : 0 }}
                      </p>
                    </v-col>

                    <!-- home -->
                    <v-col md="4" align-self="center">
                      <p class="body-2 text-start">
                        Money Line :
                        <span class="font-weight-medium"
                          >{{
                            item.HomeTeamMoneyLine ? item.HomeTeamMoneyLine : 0
                          }}
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <!-- dialog -->
      <v-dialog v-model="dialog" max-width="1000">
        <v-card class="pa-2">
          <line-combination :depthChart="Arr" />
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn color="red darken-1" text @click="dialog = false">
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog ends -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import lineCombination from "@/components/Lists/lineCombination.vue";

export default {
  name: "NhlGoaliesSection",
  components: { lineCombination },

  created() {
    this.$store.dispatch("NhlModule/fetchGoalies");
  },

  computed: {
    ...mapState("NhlModule", ["goaliesData"]),
    ...mapGetters("NhlModule", ["getGoalieLoader"]),

    goalies() {
      if (this.goaliesData.data.length > 0) {
        return this.goaliesData.data.slice(0, 1);
      }
    },
  },
};
</script>

<style scoped></style>
